/* tslint:disable */
/* eslint-disable */
/**
 * Sellsen API
 * Ürün Tarama ve SP-API Entegrasyonu
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * @export
 */
export const InventorySourceStatusEnum = {
    Pending: 'PENDING',
    InQueue: 'IN_QUEUE',
    Processing: 'PROCESSING',
    Success: 'SUCCESS',
    Failed: 'FAILED',
    Canceled: 'CANCELED'
};
/**
 * @export
 */
export const InventorySourceMerchantTypeEnum = {
    Fba: 'FBA',
    Fbm: 'FBM',
    Sba: 'SBA'
};
/**
 * Check if a given object implements the InventorySource interface.
 */
export function instanceOfInventorySource(value) {
    return true;
}
export function InventorySourceFromJSON(json) {
    return InventorySourceFromJSONTyped(json, false);
}
export function InventorySourceFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'createdBy': json['createdBy'] == null ? undefined : json['createdBy'],
        'createdDate': json['createdDate'] == null ? undefined : (new Date(json['createdDate'])),
        'lastModifiedBy': json['lastModifiedBy'] == null ? undefined : json['lastModifiedBy'],
        'lastModifiedDate': json['lastModifiedDate'] == null ? undefined : (new Date(json['lastModifiedDate'])),
        'id': json['id'] == null ? undefined : json['id'],
        'purchasePriceUsd': json['purchasePriceUsd'] == null ? undefined : json['purchasePriceUsd'],
        'brand': json['brand'] == null ? undefined : json['brand'],
        'title': json['title'] == null ? undefined : json['title'],
        'imageUrl': json['imageUrl'] == null ? undefined : json['imageUrl'],
        'rootCategory': json['rootCategory'] == null ? undefined : json['rootCategory'],
        'leafCategory': json['leafCategory'] == null ? undefined : json['leafCategory'],
        'reviewRating': json['reviewRating'] == null ? undefined : json['reviewRating'],
        'reviewCount': json['reviewCount'] == null ? undefined : json['reviewCount'],
        'categoryBsr': json['categoryBsr'] == null ? undefined : json['categoryBsr'],
        'subcategoryBsr': json['subcategoryBsr'] == null ? undefined : json['subcategoryBsr'],
        'status': json['status'] == null ? undefined : json['status'],
        'merchantType': json['merchantType'] == null ? undefined : json['merchantType'],
        'availability': json['availability'] == null ? undefined : json['availability'],
        'itemHeight': json['itemHeight'] == null ? undefined : json['itemHeight'],
        'itemLength': json['itemLength'] == null ? undefined : json['itemLength'],
        'itemWidth': json['itemWidth'] == null ? undefined : json['itemWidth'],
        'itemWeight': json['itemWeight'] == null ? undefined : json['itemWeight'],
        'sourceQueuedAt': json['sourceQueuedAt'] == null ? undefined : (new Date(json['sourceQueuedAt'])),
        'sourceInfoLastModifiedDate': json['sourceInfoLastModifiedDate'] == null ? undefined : (new Date(json['sourceInfoLastModifiedDate'])),
        'minOrderQuantity': json['minOrderQuantity'] == null ? undefined : json['minOrderQuantity'],
        'maxOrderQuantity': json['maxOrderQuantity'] == null ? undefined : json['maxOrderQuantity'],
        'isBestSeller': json['isBestSeller'] == null ? undefined : json['isBestSeller'],
        'sourceShippingPriceUsd': json['sourceShippingPriceUsd'] == null ? undefined : json['sourceShippingPriceUsd'],
        'sourceTotalOfferCount': json['sourceTotalOfferCount'] == null ? undefined : json['sourceTotalOfferCount'],
        'sourcePrimeOfferCount': json['sourcePrimeOfferCount'] == null ? undefined : json['sourcePrimeOfferCount'],
        'deliveryPromiseDays': json['deliveryPromiseDays'] == null ? undefined : json['deliveryPromiseDays'],
        'returnable': json['returnable'] == null ? undefined : json['returnable'],
        'freeReturns': json['freeReturns'] == null ? undefined : json['freeReturns'],
        'returnWindowDays': json['returnWindowDays'] == null ? undefined : json['returnWindowDays'],
        'amazonsChoice': json['amazonsChoice'] == null ? undefined : json['amazonsChoice'],
        'primeExclusive': json['primeExclusive'] == null ? undefined : json['primeExclusive'],
        'availableQuantity': json['availableQuantity'] == null ? undefined : json['availableQuantity'],
        'voltage': json['voltage'] == null ? undefined : json['voltage'],
        'bulbBase': json['bulbBase'] == null ? undefined : json['bulbBase'],
        'powerSource': json['powerSource'] == null ? undefined : json['powerSource'],
        'sourceSellerId': json['sourceSellerId'] == null ? undefined : json['sourceSellerId'],
        'sourceSellerName': json['sourceSellerName'] == null ? undefined : json['sourceSellerName'],
        'sourceSellerCountry': json['sourceSellerCountry'] == null ? undefined : json['sourceSellerCountry'],
        'sourceType': json['sourceType'] == null ? undefined : json['sourceType'],
        'sourceId': json['sourceId'] == null ? undefined : json['sourceId'],
        'asin': json['asin'] == null ? undefined : json['asin'],
        'searchId': json['searchId'] == null ? undefined : json['searchId'],
        'seller': json['seller'] == null ? undefined : json['seller'],
    };
}
export function InventorySourceToJSON(json) {
    return InventorySourceToJSONTyped(json, false);
}
export function InventorySourceToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'createdBy': value['createdBy'],
        'createdDate': value['createdDate'] == null ? undefined : ((value['createdDate']).toISOString()),
        'lastModifiedBy': value['lastModifiedBy'],
        'lastModifiedDate': value['lastModifiedDate'] == null ? undefined : ((value['lastModifiedDate']).toISOString()),
        'id': value['id'],
        'purchasePriceUsd': value['purchasePriceUsd'],
        'brand': value['brand'],
        'title': value['title'],
        'imageUrl': value['imageUrl'],
        'rootCategory': value['rootCategory'],
        'leafCategory': value['leafCategory'],
        'reviewRating': value['reviewRating'],
        'reviewCount': value['reviewCount'],
        'categoryBsr': value['categoryBsr'],
        'subcategoryBsr': value['subcategoryBsr'],
        'status': value['status'],
        'merchantType': value['merchantType'],
        'availability': value['availability'],
        'itemHeight': value['itemHeight'],
        'itemLength': value['itemLength'],
        'itemWidth': value['itemWidth'],
        'itemWeight': value['itemWeight'],
        'sourceQueuedAt': value['sourceQueuedAt'] == null ? undefined : ((value['sourceQueuedAt']).toISOString()),
        'sourceInfoLastModifiedDate': value['sourceInfoLastModifiedDate'] == null ? undefined : ((value['sourceInfoLastModifiedDate']).toISOString()),
        'minOrderQuantity': value['minOrderQuantity'],
        'maxOrderQuantity': value['maxOrderQuantity'],
        'isBestSeller': value['isBestSeller'],
        'sourceShippingPriceUsd': value['sourceShippingPriceUsd'],
        'sourceTotalOfferCount': value['sourceTotalOfferCount'],
        'sourcePrimeOfferCount': value['sourcePrimeOfferCount'],
        'deliveryPromiseDays': value['deliveryPromiseDays'],
        'returnable': value['returnable'],
        'freeReturns': value['freeReturns'],
        'returnWindowDays': value['returnWindowDays'],
        'amazonsChoice': value['amazonsChoice'],
        'primeExclusive': value['primeExclusive'],
        'availableQuantity': value['availableQuantity'],
        'voltage': value['voltage'],
        'bulbBase': value['bulbBase'],
        'powerSource': value['powerSource'],
        'sourceSellerId': value['sourceSellerId'],
        'sourceSellerName': value['sourceSellerName'],
        'sourceSellerCountry': value['sourceSellerCountry'],
        'sourceType': value['sourceType'],
        'sourceId': value['sourceId'],
        'asin': value['asin'],
        'searchId': value['searchId'],
        'seller': value['seller'],
    };
}
